import React, { useState } from "react";
import {
    Box, Grid, Typography
} from "@mui/material";
import { Form, Input, Upload, Button, message, Select } from 'antd';
import { InboxOutlined } from '@ant-design/icons';
import AppHeader from "../../../components/Dashboard/AppHeader";
import userStore from "../../../zustand/store/userStore";
import { addCourseAPI } from "../../../zustand/API";
import { Content } from "antd/es/layout/layout";


const AddCourse = ({ notification }) => {
    const [form] = Form.useForm();
    const [fileList, setFileList] = useState([]);
    const { user } = userStore();
    const [loading, setLoading] = useState(false);

    const handleFileChange = info => {
        setFileList(info.fileList);
    };

    const onFinish = async (values) => {
        setLoading(true); 
        try {
            const formData = new FormData();
            formData.append("file", fileList[0]?.originFileObj);
            formData.append("email", user?.email);
            formData.append("subjectName", values.subjectName);
            formData.append("className", values.className);
            formData.append("chapterName", values.chapterName);

            const response = await addCourseAPI(formData);
            if (response.status === 200) {
                message.success(response?.data?.message);
                form.resetFields();
                setFileList([]);
            }
        } catch (error) {
            console.log('API Error:', error);
            message.error("Something went wrong during upload.");
        } finally {
            setLoading(false); 
        }
    };


    return (
        <Content className="p-2">
            <AppHeader
                title={'Add Course'}
                content={"Purpose: Enable teachers to create new courses for students."}
                notification={notification}
            />
            <Box sx={{
                mt: 5, p: 3,
                border: "2px solid black", borderRadius: 2,
                boxShadow: "2px 2px 10px rgba(0,0,0,0.1)"
            }}>
                <Form form={form} layout="vertical" onFinish={onFinish}>
                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <Form.Item name="subjectName" label="Subject Name" rules={[{ required: true, message: 'Please enter a subject name' }]}>
                                <Input placeholder="Enter subject name" />
                            </Form.Item>
                        </Grid>
                        <Grid item xs={6}>
                            <Form.Item
                                name="className"
                                label="Class Name"
                                rules={[{ required: true, message: 'Please select a class' }]}
                            >
                                <Select
                                    placeholder="Select class"
                                    allowClear
                                    style={{ width: '100%' }}
                                    defaultActiveFirstOption
                                >
                                    {[9, 10, 11, 12].map((num) => (
                                        <Select.Option key={num} value={num.toString()}>
                                            {num}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>

                        </Grid>
                        <Grid item xs={6}>
                            <Form.Item name="resources" label="Resources (Optional file upload)">
                                <Upload.Dragger
                                    beforeUpload={() => false}
                                    onChange={handleFileChange}
                                    fileList={fileList}
                                    multiple={false}
                                >
                                    <p className="ant-upload-drag-icon"><InboxOutlined /></p>
                                    <p>Drag your file(s) or <a href="#">browse</a></p>
                                    <p>Max 10 MB files are allowed</p>
                                </Upload.Dragger>
                            </Form.Item>
                        </Grid>
                        <Grid item xs={6}>
                            <Form.Item name="chapterName" label="Chapter Name" rules={[{ required: true, message: 'Please enter a chapter name' }]}>
                                <Input placeholder="Enter chapter name" />
                            </Form.Item>
                        </Grid>
                    </Grid>
                    <Form.Item>
                        <Button
                            type="primary"
                            htmlType="submit"
                            loading={loading}
                            style={{ backgroundColor: "#22C55E", borderColor: "black", marginTop: 16 }}
                        >
                            Save Course
                        </Button>

                    </Form.Item>
                </Form>
            </Box>
        </Content>
    );
};

export default AddCourse;